import { CustomOption } from "core/catalog";
import { cn } from "core/shared";
import { useState } from "react";
import { LabelInput } from "~/design-system/components";
import { CustomOptionLabel } from "./CustomOptionLabel";

type ColorInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string | string[]) => void;
};

export function ColorInputOption({
  customOption,
  onChange,
}: ColorInputOptionProps) {
  const [selectedValue, setSelectedValue] = useState<string>("");

  const handleSelectValue = (value: string) => {
    if (selectedValue && selectedValue === value) {
      setSelectedValue("");
      onChange?.("");
    } else {
      setSelectedValue(value);
      onChange?.(value);
    }
  };

  if (customOption.values?.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-3">
      <LabelInput htmlFor={customOption.id} className="w-fit">
        <CustomOptionLabel customOption={customOption} />
      </LabelInput>
      {/* Color options */}
      <div className="flex flex-wrap items-center gap-2 px-2">
        {customOption.values?.map((value) => (
          <button
            key={value.id}
            title={value.name}
            aria-label={value.name}
            className={cn(
              "flex cursor-pointer flex-col items-center gap-2 overflow-hidden rounded-xl border-2 border-transparent shadow-[0_3px_10px_rgb(0,0,0,0.1)]",
              selectedValue &&
                (selectedValue === value.id
                  ? "border-black"
                  : "border-transparent opacity-50"),
            )}
            onClick={() => handleSelectValue(value.id)}
          >
            <span
              className="size-10"
              style={{ backgroundColor: value.color }}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
